import style from './_style.less';
import styleScss from './_style.scss';
import customselect from './components/custom-select/index';

require('./../shared/js/select2modify/select2modify');

require('./../shared/js/select2modify/i18n/cs');

require('./front/js/main');

customselect();
